import { render, staticRenderFns } from "./page17.vue?vue&type=template&id=4a381046&scoped=true&"
import script from "./page17.vue?vue&type=script&lang=js&"
export * from "./page17.vue?vue&type=script&lang=js&"
import style0 from "./page17.vue?vue&type=style&index=0&id=4a381046&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a381046",
  null
  
)

export default component.exports